import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../hooks/useApi";

export default function AddBudgetLines() {
    const [codeData, setCodeData] = useState({});
    const { apiCall } = useApi();
    const baseName = import.meta.env.VITE_APP_BASE_URL;

    const setData = (key, value) => {
        setCodeData((prevData) => ({ ...prevData, [key]: value }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const response = await apiCall(`costcodes-add_budget_lines`, {
                method: "POST",
                body: codeData,
            });
            const data = await response.json();
            if (!data.success) {
                throw new Error(data.error);
            }

            alert("Budget line added successfully!");
            const action = e.nativeEvent.submitter?.name;
            if (action == 'submitAndStay') {
                setCodeData({});
            }
            else {
                window.location.href = window.location.origin + baseName + `cost-codes`;
            }

        } catch (error) {
            console.error("Error adding the code:", error);
            alert(error);
        }
    }

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-10">
                <h1 className="text-2xl font-bold">Add New Code</h1>
                <Link to={`/cost-codes/`} className="btn btn-primary self-end">
                    Back
                </Link>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
                <input
                    type="text"
                    placeholder="Cost Code ID (DBID)"
                    value={codeData?.dbid || ""}
                    onChange={(e) => setData('dbid', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="number"
                    min="1"
                    placeholder="Budget Line ID (B_DBID)"
                    value={codeData?.b_dbid || ""}
                    onChange={(e) => setData('b_dbid', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Budget Line"
                    value={codeData?.budget_line || ""}
                    onChange={(e) => setData('budget_line', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <div className="flex flex-col gap-2">
                    <button className="btn btn-primary" name="submitAndRedirect">Add Budget Line and Go back.</button>
                    <button className="btn btn-primary" name="submitAndStay">Add Budget Line + Stay on the page</button>
                    <Link to={`/cost-codes/`}>
                        <button type="button" className="btn btn-cancel">Cancel</button>
                    </Link>
                </div>

            </form>
        </div>
    );
};